export const interviewTypes = [
	'INTERVIEW-1',
	'INTERVIEW-2',
	'INTERVIEW-3',
	'INTERVIEW-4',
	'INTERVIEW-5',
	'INTERVIEW-6',
	'INTERVIEW-7',
];
